module.exports = __webpack_public_path__ + "img/image1.533c2047.png";